module.exports = __webpack_public_path__ + "img/foot_logo.be4aa2a5.png";